import { createSlice } from '@reduxjs/toolkit';

const initialKurbanListState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    kurbanListForEdit: undefined,
    lastError: null,
};

export const callTypes = {
    list: 'list',
    action: 'action',
};

export const kurbanSlice = createSlice({
    name: 'kurbanList',
    initialState: initialKurbanListState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },

        // findKurbanLists
        kurbanListsFetched: (state, action) => {
            // const { total_items, items, kurbanList_item_array } = action.payload;
            const { total_items, items } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = items;
            state.totalCount = total_items;
            // state.kurbanList_item_array = kurbanList_item_array
        },

        // Set to default state actionLoading & error
        kurbanListReload: (state, action) => {
            state.actionsLoading = false;
            state.listLoading = false;
            state.error = null;
        },

    },
});

